import React, { useState } from 'react';
import { Card, Table, Collapsible, CollapsibleItem, Icon } from "react-materialize";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default ({ data }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const handleCollapsibleClick = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <Card className="dashboard-collapsible-section">
            <Collapsible accordion>
                <CollapsibleItem
                    expanded={isExpanded}
                    onClick={handleCollapsibleClick}
                    header={(
                        <div className="dashboard-collapsible-header">
                            <span className="collapsible-title">Customer Averages</span>
                            <Icon>{isExpanded ? 'expand_less' : 'expand_more'}</Icon>
                        </div>
                    )}
                >
                    <Table responsive={true} hoverable={true}>
                        <thead>
                            <tr>
                                <th className="align-center">Total Customers</th>
                                <th className="align-center">Active Customers</th>
                                <th className="align-center">Request/Customer</th>
                                <th className="align-center">Completed/Customer</th>
                                <th className="align-center">Time/Customer</th>
                                <th className="align-center"><FontAwesomeIcon icon="star" color="#FFD700" size="xs" title="☆" />Rating/Customer</th>
                                <th className="align-center">Total Ratings</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="align-center">{data?.customer_data?.customer_averages?.total_customers}</td>
                                <td className="align-center">{data?.customer_data?.customer_averages?.active_customers}</td>
                                <td className="align-center">{data?.customer_data?.customer_averages?.average_requests?.toFixed(2)}</td>
                                <td className="align-center">{data?.customer_data?.customer_averages?.average_completed?.toFixed(2)}</td>
                                <td className="align-center">{data?.customer_data?.customer_averages?.average_time?.toFixed(2)} hours</td>
                                <td className="align-center">{data?.customer_data?.customer_averages?.average_rating?.toFixed(2)}</td>
                                <td className="align-center">{data?.customer_data?.customer_averages?.total_ratings}</td>
                            </tr>
                        </tbody>
                    </Table>
                </CollapsibleItem>
            </Collapsible>
        </Card>
    );
}
